import { render } from "./stage-quotation.component.vue?vue&type=template&id=0150b564&scoped=true"
import script from "./stage-quotation.component.vue?vue&type=script&lang=js"
export * from "./stage-quotation.component.vue?vue&type=script&lang=js"

import "./stage-quotation.component.vue?vue&type=style&index=0&id=0150b564&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0150b564"]])

export default __exports__